// front-end/multimodal/src/HiddenAudioPlayer.tsx
import React, { useRef, useEffect } from 'react';

interface HiddenAudioPlayerProps {
  uri?: string | null;
  onPlay?: () => void;
}

const HiddenAudioPlayer: React.FC<HiddenAudioPlayerProps> = ({ uri, onPlay = () => {} }) => {
    const audioRef = useRef<HTMLAudioElement>(null);
    const previousUriRef = useRef<string | null | undefined>('');

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key.toLowerCase() === 'w' && audioRef.current) {
                audioRef.current.currentTime = 0;
                audioRef.current.play().catch(error => console.error('Error playing audio:', error));
            }
        };
        window.addEventListener('keydown', handleKeyDown);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    useEffect(() => {
        const audioPlayer = audioRef.current;
        if (!audioPlayer) {
            return;
        }

        if (uri !== audioPlayer.src) {
            audioPlayer.src = uri || '';
            audioPlayer.load();
            previousUriRef.current = uri;
            // Note: Play is not explicitly called here, relies on subsequent conditions or autoplay.
        } else if (uri === previousUriRef.current && uri) { // Added uri check to prevent playing if current uri is null/undefined
            audioPlayer.currentTime = 0;
            audioPlayer.play().catch(error => console.error('[HiddenAudioPlayer] Error playing audio (same URI): ', error));
        } else {
        }

        // This block is crucial for playing when URI is set and player is paused.
        if (uri && audioPlayer.src === uri && audioPlayer.paused) {
            audioPlayer.play().catch(error => console.error('[HiddenAudioPlayer] Error playing audio (paused check): ', error));
        } else {
        }
    }, [uri]);

    useEffect(() => {
        const audioPlayer = audioRef.current;
        if (!audioPlayer || !onPlay) return;

        const playHandler = () => onPlay();
        audioPlayer.addEventListener('play', playHandler);

        return () => {
            audioPlayer.removeEventListener('play', playHandler);
        };
    }, [onPlay, uri]);

    return uri ? <audio ref={audioRef} title="'w' to replay Word" /> : null;
};

export default HiddenAudioPlayer;